import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Edit(): React.ReactElement {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#edit_icon)">
        <path d="M8.70457 3.35702L11.5525 6.20491L4.34362 13.4138L1.49732 10.5659L8.70457 3.35702ZM13.7135 2.67017L12.4434 1.40011C11.9526 0.909274 11.1556 0.909274 10.6631 1.40011L9.4465 2.6167L12.2944 5.46462L13.7135 4.04553C14.0942 3.66481 14.0942 3.05086 13.7135 2.67017ZM0.00694851 14.5688C-0.0448799 14.8021 0.165716 15.0111 0.398997 14.9544L3.57252 14.1849L0.72622 11.337L0.00694851 14.5688Z" />
      </g>
      <defs>
        <clipPath id="edit_icon">
          <rect width="14" height="14" fill="white" transform="translate(-0.000976562 0.998047)"/>
        </clipPath>
      </defs>
    </svg>
  );
}
